/**
 * 右カラム設定帯: 解析タイプに応じたグラフ設定パネル（図ルーティングと共有）
 */

import KeisukeDashboardChartRouter from './KeisukeDashboardChartRouter';

export default function KeisukeDashboardChartSettingsSlot() {
  return <KeisukeDashboardChartRouter layout="split-settings" isCalculating={false} />;
}
